// src/utils/rmaHandlers.ts
import { NavigateFunction } from "react-router-dom";
import config from "../../config";
import { RmaData } from "./rmaTypes";
import { authFetch } from "../Security/authFetch";
import ses from "../../Assets/ses.jpg";
import { getSignatureLines } from "../emailSignature";
const comment = localStorage.getItem("comment");

const email = localStorage.getItem("email");
const fetchcustomerEmails = async (data: RmaData): Promise<string[]> => {
  const responseEmails = await authFetch(
      `${config.apiBaseUrl}/api/users/email-by-id?id=${data.foruserid}`
  );
  if (!responseEmails.ok)
    throw new Error(`HTTP error! status: ${responseEmails.status}`);

  const emails = await responseEmails.json();

  return emails;
};
const postMessage = async (payload: any) => {
  return authFetch(`${config.apiBaseUrl}/api/messages`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
};

export const handleEdit = async (
    data: RmaData,
    navigate: NavigateFunction,
    fetchMessages: () => void,
    relatedObjectChanged: boolean
) => {
  const username = localStorage.getItem("username") || "System";

  const payload = {
    username,
    message: `Rma With Id ${data.ticketId} Edited.`,
    date: new Date().toISOString(),
    read: false,
    ticketId: data.ticketId,
  };

  try {
    const res = await postMessage(payload);
    if (res.ok) fetchMessages();
    else console.error("Failed to save message");
  } catch (e) {
    console.error("Error while saving message:", e);
  }

  if (relatedObjectChanged) {
    try {
      const emails = await fetchcustomerEmails(data);

      const bcom = [
        "p.horkos@bcomsat.com",
        "m.matta@bcomsat.com",
        "a.hanna@bcomsat.com",
        "c.nakhle@bcomsat.com",
        "g.kattan@bcomsat.com",
      ];

      const emailBody = `
        Hello , <br><br>
        A ticket with ID ${
          data.ticketId ?? ""
      } has been Edited with the following comment: <br><br>
        Ticket ID: ${data.ticketId}<br>
        Status: ${data.status}<br>
        Ticket creation date/time: ${
          data.ticketCreationDatetime
              ? new Date(data.ticketCreationDatetime)
                  .toISOString()
                  .replace("T", " ")
                  .split(".")[0]
              : ""
      }<br>
        Ticket closure date/time: ${data.ticketClosureDatetime ?? ""}<br>
        Customer: ${data.affectedCustomer ?? ""} <br>
        Track Stage: ${data.trackstage ?? ""} <br>
        Point of contact: ${data.pointofcontact ?? ""}<br>
        Brand: ${data.brand ?? ""}  <br>
        Model: ${data.model ?? ""}<br>
        Part number: ${data.partnumber ?? ""} <br>
        Serial number: ${data.serialnumber ?? ""} <br>
        Password (optional):  ${data.password ?? ""}<br>
        Fault Description/Analysis/Troubleshooting: ${
          data.faultdescription ?? ""
      }<br>
        Network:  ${data.affectedNetwork ?? ""}<br>
        Site: ${data.affectedSite ?? ""} <br>
        Active warranty (yes or no): ${data.activewarranty ?? ""}<br>
        Is customer importer of the record? (yes or no): ${data.ior ?? ""}<br>
        Company name: ${data.companyname ?? ""} <br>
        Name: ${data.name ?? ""} <br>
        Email: ${data.email ?? ""} <br>
        Phone number:  ${data.phonenumber ?? ""}<br>
        Address line1: ${data.address1 ?? ""} <br>
        Address line2: ${data.address2 ?? ""} <br>
        City:  ${data.city ?? ""}<br>
        Region:  ${data.region ?? ""}<br>
        Country: ${data.country ?? ""} <br>
        Zip:  ${data.zip ?? ""}<br>
        <br>
       <p>Regards,<br><br><br><br></p>
              <a href=https://bdm.bcomsat.com target="_blank" style="color: #2a1364; font-weight: bold; text-decoration: none;">
                👉 View RMA Details
              </a>
            </p>
            
            <table cellpadding="0" cellspacing="0" border="0" style="margin-top: 20px;">
      <tr>
        <td style="vertical-align: top; padding-right: 12px;">

         <img src="cid:seslogo" alt="SES Logo" style="height:50px;width:auto;" />
      

        </td>

        <td>
          <div style="
            padding: 12px;
            border-left: 4px solid #2a1364;
            background-color: #f9f9f9;
            color: #2a1364;
            font-size: 13px;
          ">
            <strong>Managed Services Operations</strong><br>
            ${getSignatureLines(data.affectedCustomer, "#2a1364")}
          </div>
        </td>
      </tr>
    </table>
      `;

      // Send email to BCOM
      await authFetch(`${config.apiBaseUrl}/api/email/send`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          to: bcom,
          subject: `A RMA with ID ${data.ticketId} has been Edited.`,
          body: emailBody,
        }),
      });

      // Send email to customers
      if (emails.length > 0) {
        await authFetch(`${config.apiBaseUrl}/api/email/send`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            to: emails,
            subject: `Your RMA with ID ${data.ticketId} has been Edited.`,
            body: emailBody,
          }),
        });
      }
    } catch (emailErr) {
      console.error("Failed to send email notification:", emailErr);
    }
  }

  navigate(`/rma-edit/${data.ticketId}`, { state: { rma: data } });
};
export const handleAccept = async (
    data: RmaData,
    fetchMessages: () => void
) => {
  const username = localStorage.getItem("username") || "System";
  const payload = {
    username,
    message: `Rma With Id ${data.ticketId} Accepted.`,
    date: new Date().toISOString(),
    read: false,
    ticketId: data.ticketId,
  };

  try {
    const msgRes = await postMessage(payload);
    const updRes = await authFetch(
        `${config.apiBaseUrl}/api/rmas/${data.ticketId}/accept`,
        { method: "PUT" }
    );

    if (msgRes.ok && updRes.ok) {
      fetchMessages();
      window.location.reload();
    } else {
      console.error("Failed to accept or save message");
    }
  } catch (e) {
    console.error("Error while accepting rma:", e);
  }
  if (data) {
    const isallsite = localStorage.getItem("isAllSite");
    const isallnetwork = localStorage.getItem("isAllNetwork");
    const isalllink = localStorage.getItem("isAllLink");
    const siteInfo =
        isallsite === "true" ? "All Site" : data.affectedSite ?? "";
    const linkInfo =
        isalllink === "true" ? "All Link" : data.affectedLink ?? "";
    const networkInfo =
        isallnetwork === "true" ? "All Network" : data.affectedNetwork ?? "";
    const bcom = [
      "p.horkos@bcomsat.com",
      "m.matta@bcomsat.com",
      "a.hanna@bcomsat.com",
      "c.nakhle@bcomsat.com",
      "g.kattan@bcomsat.com",
    ];
    const jackson = ["jacksondoumith006@gmail.com", "g.kattan@bcomsat.com"];
    try {
      await authFetch(`${config.apiBaseUrl}/api/email/send`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },

        body: JSON.stringify({
          to: bcom,
          subject: `A RMA with ID ${data.ticketId}  has put been in progress.`,
          body: `Hello, <br><br>
                     A ticket with ID ${
              data.ticketId
          } is now in progress with the following comment: <br><br>

              Ticket ID:${data.ticketId}<br>
Status: In Progress<br>

Ticket creation date/time: ${
              data.ticketCreationDatetime
                  ? new Date(data.ticketCreationDatetime)
                      .toISOString()
                      .replace("T", " ")
                      .split(".")[0]
                  : ""
          } <br>
Ticket closure date/time:  ${
              data.ticketClosureDatetime
                  ? data.ticketClosureDatetime.replace("T", " ")
                  : ""
          }<br>
          Track Stage: ${data.trackstage ?? ""} <br>
Customer: ${data.affectedCustomer ?? ""} <br>
Point of contact:  ${data.pointofcontact ?? ""}<br>
brand: ${data.brand ?? ""} <br>
Model: ${data.model ?? ""}<br>
Part number: ${data.partnumber ?? ""} <br>
Serial number: ${data.serialnumber ?? ""} <br>
Password (optional):  ${data.password ?? ""}<br>
Fault Description/Analysis/Troubleshooting: ${data.faultdescription ?? ""}<br>
Customer: ${data.affectedCustomer ?? ""}<br>
Network:  ${data.affectedNetwork ?? ""}<br>
Site: ${data.affectedSite ?? ""} <br>
Active warranty (yes or no): ${data.activewarranty ?? ""}<br>
Is customer importer of the record? (yes or no): ${data.ior ?? ""}<br>
Company name: ${data.companyname ?? ""} <br>
Name: ${data.name ?? ""} <br>
Email: ${data.email ?? ""} <br>
Phone number:  ${data.phonenumber ?? ""}<br>
Address line1: ${data.address1 ?? ""} <br>
Address line2: ${data.address2 ?? ""} <br>
City:  ${data.city ?? ""}<br>
Region:  ${data.region ?? ""}<br>
Country: ${data.country ?? ""} <br>
Zip:  ${data.zip ?? ""}<br>
              <br>
             <p>Regards,<br><br><br><br></p>
              <a href=https://bdm.bcomsat.com target="_blank" style="color: #2a1364; font-weight: bold; text-decoration: none;">
                👉 View RMA Details
              </a>
            </p>
            
            <table cellpadding="0" cellspacing="0" border="0" style="margin-top: 20px;">
      <tr>
        <td style="vertical-align: top; padding-right: 12px;">

         <img src="cid:seslogo" alt="SES Logo" style="height:50px;width:auto;" />
      

        </td>

        <td>
          <div style="
            padding: 12px;
            border-left: 4px solid #2a1364;
            background-color: #f9f9f9;
            color: #2a1364;
            font-size: 13px;
          ">
            <strong>Managed Services Operations</strong><br>
            ${getSignatureLines(data.affectedCustomer, "#2a1364")}
          </div>
        </td>
      </tr>
    </table>
      </div>
            `,
        }),
      });
      //console.log("Email sent successfully!");
    } catch (emailErr) {
      console.error("Failed to send email notification:", emailErr);
    }
  }
};

export const handleClose = async (data: RmaData, fetchMessages: () => void) => {
  const username = localStorage.getItem("username") || "System";
  const payload = {
    username,
    message: `Rma With Id ${data.ticketId} Closed.`,
    date: new Date().toISOString(),
    read: false,
    ticketId: data.ticketId,
  };

  try {
    const msgRes = await postMessage(payload);
    const updRes = await authFetch(
        `${config.apiBaseUrl}/api/rmas/${
            data.ticketId
        }/close?user=${encodeURIComponent(username)}`,
        { method: "PUT" }
    );

    if (data) {
      const emails = await fetchcustomerEmails(data);
      const bcom = [
        "p.horkos@bcomsat.com",
        "m.matta@bcomsat.com",
        "a.hanna@bcomsat.com",
        "c.nakhle@bcomsat.com",
        "g.kattan@bcomsat.com",
      ];
      const now = new Date();
      data.ticketClosureDatetime = now.toISOString();

      const emailBody = `
        Hello , <br><br>
        A ticket with ID ${data.ticketId} has been closed.<br><br>
        Ticket ID: ${data.ticketId}<br>
        Status: Closed<br>
        Ticket creation date/time: ${
          data.ticketCreationDatetime
              ? new Date(data.ticketCreationDatetime)
                  .toISOString()
                  .replace("T", " ")
                  .split(".")[0]
              : ""
      }<br>
        Ticket closure date/time: ${
          now.toISOString().replace("T", " ").split(".")[0]
      }<br>
        Track Stage: ${data.trackstage ?? ""}<br>
        Customer: ${data.affectedCustomer ?? ""} <br>
        Point of contact: ${data.pointofcontact ?? ""}<br>
        Brand: ${data.brand ?? ""} <br>
        Model: ${data.model ?? ""} <br>
        Part number: ${data.partnumber ?? ""} <br>
        Serial number: ${data.serialnumber ?? ""} <br>
        Password (optional): ${data.password ?? ""}<br>
        Fault Description/Analysis/Troubleshooting: ${
          data.faultdescription ?? ""
      }<br>
        Solution: ${data.solution ?? ""}<br>
        Network: ${data.affectedNetwork ?? ""}<br>
        Site: ${data.affectedSite ?? ""} <br>
        Active warranty (yes or no): ${data.activewarranty ?? ""}<br>
        Is customer importer of the record? (yes or no): ${data.ior ?? ""}<br>
        Company name: ${data.companyname ?? ""} <br>
        Name: ${data.name ?? ""} <br>
        Email: ${data.email ?? ""} <br>
        Phone number: ${data.phonenumber ?? ""}<br>
        Address line1: ${data.address1 ?? ""} <br>
        Address line2: ${data.address2 ?? ""} <br>
        City: ${data.city ?? ""}<br>
        Region: ${data.region ?? ""}<br>
        Country: ${data.country ?? ""} <br>
        Zip: ${data.zip ?? ""}<br>
        <br>
        <p>Regards,<br><br><br><br></p>
              <a href=https://bdm.bcomsat.com target="_blank" style="color: #2a1364; font-weight: bold; text-decoration: none;">
                👉 View RMA Details
              </a>
            </p>
            
            <table cellpadding="0" cellspacing="0" border="0" style="margin-top: 20px;">
      <tr>
        <td style="vertical-align: top; padding-right: 12px;">

         <img src="cid:seslogo" alt="SES Logo" style="height:50px;width:auto;" />
      

        </td>

        <td>
          <div style="
            padding: 12px;
            border-left: 4px solid #2a1364;
            background-color: #f9f9f9;
            color: #2a1364;
            font-size: 13px;
          ">
            <strong>Managed Services Operations</strong><br>
            ${getSignatureLines(data.affectedCustomer, "#2a1364")}
          </div>
        </td>
      </tr>
    </table>
      `;

      // Send email to BCOM
      try {
        await authFetch(`${config.apiBaseUrl}/api/email/send`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            to: bcom,
            subject: `A RMA with ID ${data.ticketId} has been closed`,
            body: emailBody,
          }),
        });
      } catch (err) {
        console.error("Failed to send email to BCOM:", err);
      }

      // Send email to customers
      if (emails?.length) {
        try {
          await authFetch(`${config.apiBaseUrl}/api/email/send`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              to: emails,
              subject: `Your RMA with ID ${data.ticketId} has been closed`,
              body: emailBody,
            }),
          });
        } catch (err) {
          console.error("Failed to send email to customers:", err);
        }
      }
    }

    if (msgRes.ok && updRes.ok) {
      fetchMessages();
      window.location.reload();
    } else {
      console.error("Failed to close RMA or save message");
    }
  } catch (e) {
    console.error("Error while closing RMA:", e);
  }
};

export const handlePause = async (data: RmaData, fetchMessages: () => void) => {
  const username = localStorage.getItem("username") || "System";
  const payload = {
    username,
    message: `Rma With Id ${data.ticketId} Paused.`,
    date: new Date().toISOString(),
    read: false,
    ticketId: data.ticketId,
  };

  try {
    const msgRes = await postMessage(payload);
    const updRes = await authFetch(
        `${config.apiBaseUrl}/api/rmas/${data.ticketId}/pause`,
        {
          method: "PUT",
        }
    );

    if (msgRes.ok && updRes.ok) {
      fetchMessages();
      window.location.reload();
    } else {
      console.error("Failed to Pause or save message");
    }
  } catch (e) {
    console.error("Error while Pausing rma:", e);
  }
  if (data) {
    const bcom = [
      "p.horkos@bcomsat.com",
      "m.matta@bcomsat.com",
      "a.hanna@bcomsat.com",
      "c.nakhle@bcomsat.com",
      "g.kattan@bcomsat.com",
    ];
    const jackson = ["jacksondoumith006@gmail.com", "g.kattan@bcomsat.com"];
    const isallsite = localStorage.getItem("isAllSite");
    const isallnetwork = localStorage.getItem("isAllNetwork");
    const isalllink = localStorage.getItem("isAllLink");
    const siteInfo =
        isallsite === "true" ? "All Site" : data.affectedSite ?? "";
    const linkInfo =
        isalllink === "true" ? "All Link" : data.affectedLink ?? "";
    const networkInfo =
        isallnetwork === "true" ? "All Network" : data.affectedNetwork ?? "";
    try {
      await authFetch(`${config.apiBaseUrl}/api/email/send`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },

        body: JSON.stringify({
          to: bcom,
          subject: `A RMA with ID ${data.ticketId}  has been put on hold`,
          body: `
          Hello , <br><br>
                     A ticket with ID :${
              data.ticketId
          } has been  put on hold with the following comment: <br><br>

              Ticket ID:${data.ticketId}<br>
Status: Paused<br>
Ticket creation date/time: ${
              data.ticketCreationDatetime
                  ? new Date(data.ticketCreationDatetime)
                      .toISOString()
                      .replace("T", " ")
                      .split(".")[0]
                  : ""
          } <br>
Ticket closure date/time:  ${
              data.ticketClosureDatetime
                  ? data.ticketClosureDatetime.replace("T", " ")
                  : ""
          }<br>
Customer: ${data.affectedCustomer ?? ""} <br>
Track Stage : ${data.trackstage ?? ""}<br>
Point of contact:  ${data.pointofcontact ?? ""}<br>
brand: ${data.brand ?? ""} <br>
Model: ${data.model ?? ""}<br>
Part number: ${data.partnumber ?? ""} <br>
Serial number: ${data.serialnumber ?? ""} <br>
Password (optional):  ${data.password ?? ""}<br>
Fault Description/Analysis/Troubleshooting: ${data.faultdescription ?? ""}<br>
Customer: ${data.affectedCustomer ?? ""}<br>
Network:  ${data.affectedNetwork ?? ""}<br>
Site: ${data.affectedSite ?? ""} <br>
Active warranty (yes or no): ${data.activewarranty ?? ""}<br>
Is customer importer of the record? (yes or no): ${data.ior ?? ""}<br>
Company name: ${data.companyname ?? ""} <br>
Name: ${data.name ?? ""} <br>
Email: ${data.email ?? ""} <br>
Phone number:  ${data.phonenumber ?? ""}<br>
Address line1: ${data.address1 ?? ""} <br>
Address line2: ${data.address2 ?? ""} <br>
City:  ${data.city ?? ""}<br>
Region:  ${data.region ?? ""}<br>
Country: ${data.country ?? ""} <br>
Zip:  ${data.zip ?? ""}<br>
      <strong>Comment:</strong> ${comment ?? ""}</p>
              <br>
              <p>Regards,<br><br><br><br></p>
              <a href=https://bdm.bcomsat.com target="_blank" style="color: #2a1364; font-weight: bold; text-decoration: none;">
                👉 View RMA Details
              </a>
            </p>
            
            <table cellpadding="0" cellspacing="0" border="0" style="margin-top: 20px;">
      <tr>
        <td style="vertical-align: top; padding-right: 12px;">

         <img src="cid:seslogo" alt="SES Logo" style="height:50px;width:auto;" />
      

        </td>

        <td>
          <div style="
            padding: 12px;
            border-left: 4px solid #2a1364;
            background-color: #f9f9f9;
            color: #2a1364;
            font-size: 13px;
          ">
            <strong>Managed Services Operations</strong><br>
            ${getSignatureLines(data.affectedCustomer, "#2a1364")}
          </div>
        </td>
      </tr>
    </table>
      </div>
            `,
        }),
      });
      //console.log("Email sent successfully!");
    } catch (emailErr) {
      console.error("Failed to send email notification:", emailErr);
    }
  }
};

export const handleReactivate = async (
    data: RmaData,
    fetchMessages: () => void
) => {
  const username = localStorage.getItem("username") || "System";
  const payload = {
    username,
    message: `Rma With Id ${data.ticketId} Reactivated.`,
    date: new Date().toISOString(),
    read: false,
    ticketId: data.ticketId,
  };

  try {
    const msgRes = await postMessage(payload);
    const updRes = await authFetch(
        `${config.apiBaseUrl}/api/rmas/${data.ticketId}/reactivate`,
        { method: "PUT" }
    );

    if (msgRes.ok && updRes.ok) {
      fetchMessages();
      window.location.reload();
    } else {
      console.error("Failed to Reactivate or save message");
    }
  } catch (e) {
    console.error("Error while Reactivating rma:", e);
  }
  if (data) {
    const jackson = ["jacksondoumith006@gmail.com", "g.kattan@bcomsat.com"];
    const bcom = [
      "p.horkos@bcomsat.com",
      "m.matta@bcomsat.com",
      "c.nakhle@bcomsat.com",

      "a.hanna@bcomsat.com",
      "g.kattan@bcomsat.com",
    ];
    const isallsite = localStorage.getItem("isAllSite");
    const isallnetwork = localStorage.getItem("isAllNetwork");
    const isalllink = localStorage.getItem("isAllLink");
    const siteInfo =
        isallsite === "true" ? "All Site" : data.affectedSite ?? "";
    const linkInfo =
        isalllink === "true" ? "All Link" : data.affectedLink ?? "";
    const networkInfo =
        isallnetwork === "true" ? "All Network" : data.affectedNetwork ?? "";
    try {
      await authFetch(`${config.apiBaseUrl}/api/email/send`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },

        body: JSON.stringify({
          to: bcom,
          subject: `A RMA with ID ${data.ticketId} has been reactivated.`,
          body: `
          Hello , <br><br>
                     A ticket with ID :${
              data.ticketId
          } has been reactivated with the following comment: <br><br>

              Ticket ID:${data.ticketId}<br>
Status: Reactivated<br>
Ticket creation date/time: ${
              data.ticketCreationDatetime
                  ? new Date(data.ticketCreationDatetime)
                      .toISOString()
                      .replace("T", " ")
                      .split(".")[0]
                  : ""
          } <br>
Ticket closure date/time:  ${
              data.ticketClosureDatetime
                  ? data.ticketClosureDatetime.replace("T", " ")
                  : ""
          }<br>
Customer: ${data.affectedCustomer ?? ""} <br>
Track Stage : ${data.trackstage ?? ""}<br>
Point of contact:  ${data.pointofcontact ?? ""}<br>
brand: ${data.brand ?? ""} <br>
Model: ${data.model ?? ""}<br>
Part number: ${data.partnumber ?? ""} <br>
Serial number: ${data.serialnumber ?? ""} <br>
Password (optional):  ${data.password ?? ""}<br>
Fault Description/Analysis/Troubleshooting: ${data.faultdescription ?? ""}<br>
Customer: ${data.affectedCustomer ?? ""}<br>
Network:  ${data.affectedNetwork ?? ""}<br>
Site: ${data.affectedSite ?? ""} <br>
Active warranty (yes or no): ${data.activewarranty ?? ""}<br>
Is customer importer of the record? (yes or no): ${data.ior ?? ""}<br>
Company name: ${data.companyname ?? ""} <br>
Name: ${data.name ?? ""} <br>
Email: ${data.email ?? ""} <br>
Phone number:  ${data.phonenumber ?? ""}<br>
Address line1: ${data.address1 ?? ""} <br>
Address line2: ${data.address2 ?? ""} <br>
City:  ${data.city ?? ""}<br>
Region:  ${data.region ?? ""}<br>
Country: ${data.country ?? ""} <br>
Zip:  ${data.zip ?? ""}<br>
              <br>
             <p>Regards,<br><br><br><br></p>
              <a href=https://bdm.bcomsat.com target="_blank" style="color: #2a1364; font-weight: bold; text-decoration: none;">
                👉 View RMA Details
              </a>
            </p>
            
            <table cellpadding="0" cellspacing="0" border="0" style="margin-top: 20px;">
      <tr>
        <td style="vertical-align: top; padding-right: 12px;">

         <img src="cid:seslogo" alt="SES Logo" style="height:50px;width:auto;" />
      

        </td>

        <td>
          <div style="
            padding: 12px;
            border-left: 4px solid #2a1364;
            background-color: #f9f9f9;
            color: #2a1364;
            font-size: 13px;
          ">
            <strong>Managed Services Operations</strong><br>
            ${getSignatureLines(data.affectedCustomer, "#2a1364")}
          </div>
        </td>
      </tr>
    </table>
      </div>
            `,
        }),
      });
      //console.log("Email sent successfully!");
    } catch (emailErr) {
      console.error("Failed to send email notification:", emailErr);
    }
  }
};

export const handleReopen = async (
    data: RmaData,
    fetchMessages: () => void
) => {
  const username = localStorage.getItem("username") || "System";
  const payload = {
    username,
    message: `Rma With Id ${data.ticketId} Reopened.`,
    date: new Date().toISOString(),
    read: false,
    ticketId: data.ticketId,
  };

  try {
    const msgRes = await postMessage(payload);
    const updRes = await authFetch(
        `${config.apiBaseUrl}/api/rmas/${data.ticketId}/reopen`,
        { method: "PUT" }
    );

    if (msgRes.ok && updRes.ok) {
      fetchMessages();
      window.location.reload();
    } else {
      console.error("Failed to Reactivate or save message");
    }
  } catch (e) {
    console.error("Error while Reactivating rma:", e);
  }
  if (data) {
    const jackson = ["jacksondoumith006@gmail.com", "g.kattan@bcomsat.com"];
    const bcom = [
      "p.horkos@bcomsat.com",
      "m.matta@bcomsat.com",
      "a.hanna@bcomsat.com",
      "c.nakhle@bcomsat.com",
      "g.kattan@bcomsat.com",
    ];
    const isallsite = localStorage.getItem("isAllSite");
    const isallnetwork = localStorage.getItem("isAllNetwork");
    const isalllink = localStorage.getItem("isAllLink");
    const siteInfo =
        isallsite === "true" ? "All Site" : data.affectedSite ?? "";
    const linkInfo =
        isalllink === "true" ? "All Link" : data.affectedLink ?? "";
    const networkInfo =
        isallnetwork === "true" ? "All Network" : data.affectedNetwork ?? "";
    try {
      await authFetch(`${config.apiBaseUrl}/api/email/send`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },

        body: JSON.stringify({
          to: bcom,
          subject: `A RMA with ID: ${data.ticketId} has been Reopened.`,
          body: `
          Hello , <br><br>
           A ticket with ID ${
              data.ticketId
          } has been reopened with the following comment: <br><br>
              Ticket ID:${data.ticketId}<br>
Status: Reopened<br>
Ticket creation date/time: ${
              data.ticketCreationDatetime
                  ? new Date(data.ticketCreationDatetime)
                      .toISOString()
                      .replace("T", " ")
                      .split(".")[0]
                  : ""
          } <br>
Ticket closure date/time:  ${
              data.ticketClosureDatetime
                  ? data.ticketClosureDatetime.replace("T", " ")
                  : ""
          }<br>
Customer: ${data.affectedCustomer ?? ""} <br>
Track Stage : ${data.trackstage ?? ""}<br>
Point of contact:  ${data.pointofcontact ?? ""}<br>
brand: ${data.brand ?? ""} <br>
Model: ${data.model ?? ""}<br>
Part number: ${data.partnumber ?? ""} <br>
Serial number: ${data.serialnumber ?? ""} <br>
Password (optional):  ${data.password ?? ""}<br>
Fault Description/Analysis/Troubleshooting: ${data.faultdescription ?? ""}<br>
Customer: ${data.affectedCustomer ?? ""}<br>
Network:  ${data.affectedNetwork ?? ""}<br>
Site: ${data.affectedSite ?? ""} <br>
Active warranty (yes or no): ${data.activewarranty ?? ""}<br>
Is customer importer of the record? (yes or no): ${data.ior ?? ""}<br>
Company name: ${data.companyname ?? ""} <br>
Name: ${data.name ?? ""} <br>
Email: ${data.email ?? ""} <br>
Phone number:  ${data.phonenumber ?? ""}<br>
Address line1: ${data.address1 ?? ""} <br>
Address line2: ${data.address2 ?? ""} <br>
City:  ${data.city ?? ""}<br>
Region:  ${data.region ?? ""}<br>
Country: ${data.country ?? ""} <br>
Zip:  ${data.zip ?? ""}<br>

              <br>
             <p>Regards,<br><br><br><br></p>
              <a href=https://bdm.bcomsat.com target="_blank" style="color: #2a1364; font-weight: bold; text-decoration: none;">
                👉 View RMA Details
              </a>
            </p>
            
            <table cellpadding="0" cellspacing="0" border="0" style="margin-top: 20px;">
      <tr>
        <td style="vertical-align: top; padding-right: 12px;">

         <img src="cid:seslogo" alt="SES Logo" style="height:50px;width:auto;" />
      

        </td>

        <td>
          <div style="
            padding: 12px;
            border-left: 4px solid #2a1364;
            background-color: #f9f9f9;
            color: #2a1364;
            font-size: 13px;
          ">
            <strong>Managed Services Operations</strong><br>
            ${getSignatureLines(data.affectedCustomer, "#2a1364")}
          </div>
        </td>
      </tr>
    </table>
      </div>
            `,
        }),
      });
      //console.log("Email sent successfully!");
    } catch (emailErr) {
      console.error("Failed to send email notification:", emailErr);
    }
  }
};
